<template>
  <div id="copyRights" class="container">
    <footer class="footer">
      <div class="content" id="copyright-content" dir="rtl">
        <p>
          האתר נבנה ע"י
          <u>נמרוד אוסטפלד</u>
        </p>
        <p>
          כל הזכויות שמורות
          <b-icon pack="fas" icon="copyright" size="is-small" id="copyright-icon" />
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "copyRights"
};
</script>

<style scoped>
#copyright-content {
  text-align: center;
  font-weight: 500;
  font-size: 76%;
}
.link {
  color: #4a4a4a;
  text-decoration: underline;
}
#copyright-icon {
  color: #248f8f;
}
</style>
